module.exports = __webpack_public_path__ + "img/dashboard.6cb1c267.svg";